import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { AddIcon } from '../../../icons';

const AddAssumptionButton = ({ onAdd }) => {
    const [label, setLabel] = useState();

    const handleAdd = () => {
        onAdd(label);
        setLabel('');
    };

    const handleLabelChange = (e) => {
        setLabel(e.target.value);
    };

    const handleQuit = () => {
        setLabel('');
    };

    return (
        <>
            <button
                type="button"
                className="btn py-1 px-1 me-1 mb-1 lh-1 fw-bold acquisitions-add-target-button"
                data-bs-toggle="modal"
                data-bs-target="#addAssumptionModal"
                title="Add Assumption"
            >
        Add Assumption
                <AddIcon color="white" />
            </button>
            <div
                className="modal fade"
                id="addAssumptionModal"
                tabIndex="-1"
                aria-labelledby="addAssumptionLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssumptionLabel">
                Add New Assumption Row
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleQuit}
                            ></button>
                        </div>
                        <div className="modal-body text-center">
                            <TextField
                                type="text"
                                value={label ?? ''}
                                onChange={handleLabelChange}
                                variant="standard"
                                sx={{
                                    height: '100%',
                                    '& .MuiInputBase-root': {
                                        height: '100%',
                                        alignItems: 'center',
                                        padding: 0,
                                    },
                                    '& .MuiInputBase-input': {
                                        height: '100%',
                                        padding: '0 12px 0 0',
                                        boxSizing: 'border-box',
                                    },
                                }}
                                autoFocus
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAdd}
                            >
                Add Assumption
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddAssumptionButton;
